'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getWorkingStorage = getWorkingStorage;

var _CookieStorage = require('./CookieStorage');

var _CookieStorage2 = _interopRequireDefault(_CookieStorage);

var _SessionStorage = require('./SessionStorage');

var _SessionStorage2 = _interopRequireDefault(_SessionStorage);

var _SimpleStorage = require('./SimpleStorage');

var _SimpleStorage2 = _interopRequireDefault(_SimpleStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Factory method to evaluate the browsers capabilities to store session data
 * and returns a working storage object. The maximum lifetime of a session
 * depends on the chosen storage.
 *
 * @returns {CookieStorage|SessionStorage|SimpleStorage}
 */
function getWorkingStorage() {
    if ((0, _CookieStorage.hasCookieStorage)()) {
        return new _CookieStorage2.default();
    } else if ((0, _SessionStorage.hasSessionStorage)(sessionStorage)) {
        return new _SessionStorage2.default();
    } else {
        return new _SimpleStorage2.default();
    }
}
